// SopSummarySection.jsx

import React from "react";
import "./SopSummarySection.css";
import {
  FiShield,
  FiChevronsUp,
  FiUsers,
  FiFileText,
  FiLock,
} from "react-icons/fi";

const sopItems = [
  {
    icon: <FiShield />,
    title: "Dispute Categories & Workflow",
    description:
      "Types of issues covered and the step-by-step process for resolution.",
  },
  {
    icon: <FiChevronsUp />,
    title: "SLAs & Escalation",
    description:
      "Timeframes for acknowledgment, response, and how issues move up to managers.",
  },
  {
    icon: <FiUsers />,
    title: "Roles & Responsibilities",
    description:
      "What’s expected from customers, sellers, support, and platform admins.",
  },
  {
    icon: <FiFileText />,
    title: "Special Policies",
    description:
      "Refunds, privacy, legal compliance, repeat complaints, force majeure, and more.",
  },
  {
    icon: <FiLock />,
    title: "Data Security & Audit",
    description:
      "How user information is protected, tracked, and used for continuous improvement.",
  },
];

const SopSummarySection = () => {
  return (
    <section className="_sopSect_x1_">
      <div className="_sopCont_y2_">
        <h2 className="_hTitle_s5E_ features-title _hTitle_z5E_">
          Our Framework for Trust & Clarity
        </h2>

        <div className="_sopGrid_a4_">
          {sopItems.map((item, index) => (
            <div className="_sopCard_b5_ feature-item" key={index}>
              <div className="feature-icon">{item.icon}</div>
              <div className="_sopCardText_g1_">
                <h3 className="_sopCardTitle_e8_">{item.title}</h3>
                <p className="feature-description">{item.description}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default SopSummarySection;
